namespace advisorop.components.shared {

    export class AdvisorListInvestorDashboardController {
        public advisorId: number;
        public advisors: Array<domains.IInvestorAdvisor> = [];
        public dg: DevExpress.ui.dxDataGridOptions;
        //public onAdvisorChanged: (any) => any;   
        isInEditState: boolean = false;
        user: domains.identity.IUser;
        servicer: any;
        loadedAdvisors: Array<domains.IInvestorAdvisor> = [];
        currentAdvisor: domains.IAdvisor;
        advisorsListChanges: boolean = false;

        static $inject = ["advisorService", "identityService"];
        constructor(private advisorService: services.AdvisorService, private identityService: services.IdentityService) {

            this.servicer = domains.SystemLoginType.SERVICER;

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Advisors"
                },
                bindingOptions: {
                    dataSource: "vm.advisors"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: false,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgAdvisorsSettings"
                //},
                columnChooser: { enabled: false },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: { visible: false },
                wordWrapEnabled: true,
                //customizeColumns: function (columns) {
                //    columns[3].width = this.isInEditState ? 70 : 0;
                //    columns[3].visible = this.isInEditStated;
                //},
                columns: [
                    { dataField: 'advisor.fullName', caption: 'Name', cellTemplate: 'colFullName', visible: true },
                    { dataField: 'advisor.repNumber', caption: 'Rep Num.', visible: true },
                    { dataField: 'relationTypeDescription', caption: 'Relation Type', visible: true },
                    { dataField: 'id', caption: 'Actions', cellTemplate: 'btnActions', visible: this.isInEditState }
                ],
                //selection: {
                //    mode: 'single',
                //    showCheckBoxesMode: 'onClick'
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.onAdvisorChanged({ id: data.id });
                //    }
                //}
            };
        }

        //adeed code

        //assignAdvisorsForInvestor(): void {

        //    this.investor.secondaryAdvisors = this.advisors;

        //    console.log("Investor object: " + this.investor);

        //    this.advisorService.updateAdvisorInvestor(this.investor)
        //        .success((data) => {

        //            toastr.success("Investor successfully registered!");
        //            this.onCancelClicked({ editSate: this.collapseVar });
        //            this.onAssignedAdvisor({ assigned: this.collapseVar });


        //            this.investor.id = data.id;


        //        })
        //        .error((data, status) => {

        //            toastr.error("Error " + status + " : " + data);

        //        })
        //        .finally(() => {
        //            //     this.updatingAccountLadda = false;
        //        });
        //}


        getAdvisors(): void {
            this.advisorService.getAdvisorsForInvestor(this.investorId)
                .success((data) => {
                    this.advisorsListChanges = false;
                    this.advisors = data;
                    angular.copy(data, this.loadedAdvisors);
                })
                .error((status, data) => {
                    toastr.error("GETADVISOR ERROR " + status + " " + data);
                });
        };

        togglePrimarySecondary(advisor: domains.IInvestorAdvisor): void {
            var ind = this.advisors.indexOf(advisor);
            if (ind >= 0) {
                this.advisors[ind].relationType = this.advisors[ind].relationType == domains.RelationType.PRIMARY ? domains.RelationType.SECONDARY : domains.RelationType.PRIMARY;
                this.advisors[ind].relationTypeDescription = this.advisors[ind].relationType == domains.RelationType.PRIMARY ? "Primary" : "Secondary";
            }
            this.advisorsListChanges = true;
        };

        removeAdvisorFromAdvisors(advisor: domains.IInvestorAdvisor): void {
            var ind = this.advisors.indexOf(advisor);
            if (ind >= 0)
                this.advisors.splice(ind, 1);
            this.advisorsListChanges = true;
        };

        updateDeleteColumn(): void {
            $("#advisorList").dxDataGrid("instance").columnOption('Actions', 'width', this.isInEditState ? 70 : 0);
            $("#advisorList").dxDataGrid("instance").columnOption('Actions', 'visible', this.isInEditState);
        }

        changeEditState(editSate): void {
            this.isInEditState = editSate;
//            angular.copy(this.loadedAdvisors, this.advisors);
            this.updateDeleteColumn();
            if (this.advisorsListChanges)
                this.getAdvisors();
        }

        onEditClicked(): void {
            this.isInEditState = !this.isInEditState;
            this.updateDeleteColumn();
        }

        refreshGrid(assigned): void {
            this.getAdvisors();
        }
 
        okToUpdate(): boolean {
            if (this.user) {
                return (this.user.systemLoginType == domains.SystemLoginType.ADVISOR && this.user.role == domains.AdvisoryRoles.ADVISORY_ADMIN.toString());
            } else {
                return false;
            }
        }

        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                // THIS IS NOT OK !!!!

                if (this.user.systemLoginType == domains.SystemLoginType.ADVISOR) {
                    this.currentAdvisor = this.user.advisor;
                };
            });

        }

        investorId: number;

        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }            
            for (var key in evt) {
                if (key === "investorId" && !(evt[key].currentValue === evt[key].previousValue)) {
                    this.getAdvisors();
                }
            }
        }

    }

    class AdvisorListInvestorDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                investorId: "<",
            };
            this.controller = AdvisorListInvestorDashboardController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/advisor-list-investor-dashboard.html';
        }
    }
    angular.module(Constants.APP).component("advisorListInvestorDashboard", new AdvisorListInvestorDashboard());

}